import { useEffect, useMemo, useState } from "react";
import "@style/Admin.scss";
import Enums from "@/enums";

const defaultWorkflow = [
    { id: "discover", label: "Test Employees", kpi: 18, kpiLabel: "Signals" },
    { id: "align", label: "Adjust Organization", kpi: 12, kpiLabel: "Teams" },
    { id: "engage", label: "Schedule Downloads", kpi: 43, kpiLabel: "Participants" },
    { id: "act", label: "Adjust Employment", kpi: 9, kpiLabel: "Plans" }
];

export default function CompanyCultureTab(props: any) {
    const { activeTab, company } = props.tabData;
    const [selectedId, setSelectedId] = useState(defaultWorkflow[0]?.id ?? null);

    function isOnThisTab() {
        return activeTab && activeTab === "culture";
    }
    const workflowItems = useMemo(() => {
        const items = props?.tabData?.cultureWorkflow;
        if (Array.isArray(items) && items.length > 0) {
            return items;
        }
        return defaultWorkflow;
    }, [props?.tabData?.cultureWorkflow]);

    useEffect(() => {
        if (!workflowItems.find((item) => item.id === selectedId)) {
            setSelectedId(workflowItems[0]?.id ?? null);
        }
    }, [workflowItems, selectedId]);

    if (!isOnThisTab()) return null;

    const hasPermission =
        company?.permissions?.some(
            (p) =>
                p.companyId === company.id &&
                p.permissionId === Enums.ROLE_PERMS.CompanyCulture
        ) ||
        company?.permissions?.some(
            (p) =>
                p.companyId === 1 && p.permissionId === Enums.ROLE_PERMS.SystemAdmin
        );

    if (!hasPermission) {
        return (
            <div className="companyCultureTab">
                <div className="tableWrapper factTable">
                    <div className="noData">You do not have permission to view this content.</div>
                </div>
            </div>
        );
    }





    const selectedItem =
        workflowItems.find((item) => item.id === selectedId) || workflowItems[0];

    function handleItemClick(item: any) {
        setSelectedId(item.id);
        if (typeof props?.tabData?.onCultureDrill === "function") {
            props.tabData.onCultureDrill(item);
        }
    }

    return (
        <div className="companyCultureTab">
            <div className="tableWrapper factTable cultureWorkflow">
                <div className="workflowHeader">
                    <div>
                        <div className="workflowTitle">Culture workflow</div>
                        <div className="workflowSubtitle">Select a stage to drill in.</div>
                    </div>
                    <button
                        type="button"
                        className="workflowAction"
                        onClick={() => selectedItem && handleItemClick(selectedItem)}
                    >
                        View details
                    </button>
                </div>
                <div className="workflowTimeline" role="list">
                    <div className="workflowTrack" aria-hidden="true"></div>
                    <div className="workflowItems">
                        {workflowItems.map((item, index) => (
                            <button
                                key={item.id}
                                type="button"
                                role="listitem"
                                className={
                                    item.id === selectedId ? "workflowNode isActive" : "workflowNode"
                                }
                                aria-current={item.id === selectedId ? "step" : undefined}
                                onClick={() => handleItemClick(item)}
                            >
                                <div className="workflowStep">Step {index + 1}</div>
                                <div className="workflowLabel">{item.label}</div>
                                <div className="workflowKpi">{item.kpi ?? "--"}</div>
                                <div className="workflowKpiLabel">{item.kpiLabel || "KPI"}</div>
                            </button>
                        ))}
                    </div>
                </div>
                <div className="workflowDetails">
                    <div className="workflowDetailsTitle">
                        {selectedItem ? selectedItem.label : "Select a stage"}
                    </div>
                    <div className="workflowDetailsBody">
                        {selectedItem
                            ? "Add drill-in content here for the selected stage."
                            : "Choose a workflow stage to view details."}
                    </div>
                </div>
            </div>
        </div>
    );
}

